<template>
  <v-app class="bgLightGreen boiler-page" id="inspire">
    <Header back header-text="lng_eventlog"></Header>
    <v-container fluid pt-0 v-if="eventsData">
      <!-- <v-layout row wrap justify-center>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab small dark color="#455a64" 
              :outline="selectedOption === 0 ? false : true"
              @click="changeSelectedOption(0)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>select_all</v-icon>
            </v-btn>
          </template>
          <span>{{ "lng_show_all_events" | translate }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab small dark color="#455a64" 
              :outline="selectedOption === 1 ? false : true"
              @click="changeSelectedOption(1)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>settings</v-icon>
            </v-btn>
          </template>
          <span>{{ "lng_setup_events" | translate }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab small dark color="#455a64" 
              :outline="selectedOption === 2 ? false : true"
              @click="changeSelectedOption(2)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>handyman</v-icon>
            </v-btn>
          </template>
          <span>{{ "lng_service_enents" | translate }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab small dark color="#455a64" 
              :outline="selectedOption === 3 ? false : true"
              @click="changeSelectedOption(3)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>alarm</v-icon>
            </v-btn>
          </template>
          <span>{{ "lng_alarm_events" | translate }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab small dark color="#455a64" 
              :outline="selectedOption === 4 ? false : true"
              @click="changeSelectedOption(4)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>info</v-icon>
            </v-btn>
          </template>
          <span>{{ "lng_info_events" | translate }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab small dark color="#455a64" 
              :outline="selectedOption === 5 ? false : true"
              @click="changeSelectedOption(5)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>change_circle</v-icon>
            </v-btn>
          </template>
          <span>{{ "lng_state_change_events" | translate }}</span>
        </v-tooltip>

        <v-btn v-if="getAccessMode === 'smith'" dark color="#455a64" @click="fetchAllDBEvents()">{{ "lng_load_all_data" | translate }}</v-btn>
      </v-layout> -->

      <v-layout v-if="loadBulkData">
        <v-card class="mx-auto my-4" v-if="loadAll">
          <v-card-title>{{ "fetch_data_txt" | translate }}</v-card-title>
          <v-card-text>
            <p>{{ "take_long_txt" | translate }}</p>
            <v-img
              :src="require('../assets/images/spinner.svg')"
              contain
              height="100px"
            ></v-img>
          </v-card-text>
          <v-card-actions>
            <v-layout row wrap justify-center>
              <v-flex xs7 class="pr-2">
                <v-btn block flat @click="cancelBulkRequest" class="close-btn">{{
                  "lng_cancel" | translate
                }}</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>

        <v-layout v-else row wrap justify-center>
          <table v-html="legacySystemHTML" style="border-collapse: collapse;
            margin: 25px 0;
            font-size: 0.9em;
            font-family: sans-serif;
            min-width: 400px;
            border: 1px solid black;
            "></table>
        </v-layout>
      </v-layout>

      <v-layout v-else row wrap justify-center>
        <v-flex v-for="(event, index) in eventsData" :key="event.id" xs12 md12>
          <h2
            v-if="!compareDates(eventsData[index], eventsData[index - 1])"
            class="md-whiteframe-6dp"
          >
            {{ formatEventDate(event) }}
          </h2>
          <EventItem :events-data="event" />
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import EventItem from "../components/EventItem";
import GlobalService from "../services/global-service";
import moment from "moment";
import { translate } from "../common/HelperFunctions";

export default {
  components: {
    Header,
    EventItem
  },
  data: () => ({
    eventsData: [],
    bottom: false,
    offsetNumber: 0,
    selectedOption: 0,
    loadAll: false,
    allBulkData: [],
    loadBulkData: false,
    legacySystemHTML: ``
  }),
  watch: {
    bottom(bottom) {
      if (bottom) {
        this.offsetNumber += 100;
        this.FetchApisData();
      }
    }
  },
  async created() {
    // start page loading component
    this.$store.commit("global/setLoading", true);
    window.addEventListener("scroll", () => {
      this.bottom = this.bottomVisible();
    });
    await this.FetchApisData();
  },
  mounted() {
    document.getElementsByTagName("html")[0].className = "";
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
    ...mapGetters("global", ["getAccessMode"])
  },
  methods: {
    bottomVisible() {
      const scrollY = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = visible + scrollY >= pageHeight;
      return bottomOfPage || pageHeight < visible;
    },
    async FetchApisData() {
      let apiData = await GlobalService.getEventsData(
        "100",
        this.getAccessMode,
        this.offsetNumber,
        this.selectedOption,
        this.getUser.token
      );
      this.eventsData = this.eventsData.concat(apiData);
      this.$store.commit("global/setLoading", false);
    },
    compareDates(curr, prev) {
      if (!prev) return false;
      return (
        moment(curr.dt).format("YYYY-MM-DD") ===
        moment(prev.dt).format("YYYY-MM-DD")
      );
    },
    formatEventDate(event, showDay='') {
      let translation = {
        Monday: "lng_monday",
        Tuesday: "lng_tuesday",
        Wednesday: "lng_wednesday",
        Thursday: "lng_thursday",
        Friday: "lng_friday",
        Saturday: "lng_saturday",
        Sunday: "lng_sunday"
      };
      let day = moment(event.dt).format("dddd"); //jshint ignore:line
      if(showDay === 'day') return translate(translation[day])
      else {
        return (
          translate(translation[day]) +
          " " +
          moment(event.dt).format("DD/MM-YYYY")
        ); //jshint ignore:line
      }
    },
    async changeSelectedOption(option){
      if(option !== this.selectedOption){
        this.selectedOption = option;
        this.offsetNumber = 0;
        await this.FetchApisData();
      }
      if(option === 0){
        this.cancelBulkRequest();
      }
    },
    async fetchAllDBEvents(){
      this.loadAll = true;
      this.loadBulkData = true
      let bulkData = [];
      let apiData = [];
      let bulkOffsetNumber = 0;
      let data = [];
      do {
        apiData = await GlobalService.getEventsData(
          "10000",
          this.getAccessMode,
          bulkOffsetNumber,
          this.selectedOption,
          this.getUser.token
        );
        bulkOffsetNumber += 10000
        bulkData = bulkData.concat(apiData);
      } while (apiData && apiData.length);

      this.allBulkData = bulkData;
      this.makeTableFromData(bulkData);
      this.loadAll = false;
    },
    async cancelBulkRequest(){
      this.loadAll = false;
      this.loadBulkData = false;
      await this.FetchApisData();
    },
    async makeTableFromData(bulkData){
      let tab = ``;
      // Loop to access all rows 
      for (let r of bulkData) {
        tab += `<tr style="border: 1px solid black;"> 
          <td class="px-2" style="border: 1px solid black;">${this.formatEventDate(r, 'day')}</td>
          <td class="px-2" style="border: 1px solid black;">${moment(r.dt).format("DD/MM-YYYY")} <span style="margin: 0px 4px;"> </span> ${moment(r.dt).format("HH:mm:ss")}</td>
          <td><div class="flex md7 x8 mx-2">${this.renderTableRow(r)}</div></td>        
        </tr>`
      }
      this.legacySystemHTML = tab;
    },

    renderTableRow(source){
      if(source.type === '0'){
        return(
          `<span>
            <span>${translate(source.txt)} ${source.from} ${translate(source.unit)}</span> &#x2192;
            <span>${source.to} ${translate(source.unit)}</span>
          </span>`
        )
      }
      if(source.type === '1'){
        return(
          `<span>
            <span>${translate('lng_state_' + source.from)}</span> &#x2192;
            <span>${translate('lng_state_' + source.to)}</span>
          </span>`
        )
      }
      if(source.type === '2' && source.count === '0'){
        return(
          `<span>${translate(source.txt)}</span>`
        )
      }
      if(source.type === '2' && source.count === '1'){
        return(
          `<span>${translate(source.txt)} ${source.from} ${translate(source.unit)}</span>`
        )
      }      
      if(source.type === '2' && source.count === '2'){
        return(
          `<span>${translate(source.txt)} ${source.from} ${translate(source.unit)} ${source.to } ${translate(source.unit)}</span>`
        )
      }
      if(source.type === '2' && source.count === '3'){
        return(
          `<span>${translate(source.txt)} ${source.from } ${translate(source.unit)} ${source.to } ${translate(source.unit)} ${source.val3 } ${translate(source.unit)}</span>`
        )
      }
      if(source.type === '9'){
        return(
          `<span>
            <span>${translate(source.txt)}</span>
            <span> ${source.sourceid === '0' && source.to === '1' ? source.from : ""}</span>
          </span>`
        )
      }
      if(source.type === '8'){
        return(
          `<span>
            <span>${translate(source.txt)} ${source.from}</span> &#x2192;
            <span>${source.parms === '2' ? source.to : ""}</span>
          </span>`
        )
      }
      if(source.type === '4'){
        return(
          `<span>${translate('lng_info_' + source.eventid)}</span>`
        )
      }
      if(source.type === '20'){
        return(
          `<span>
            <span>${translate('state_' + source.from )}'</span> &#x2192;
            <span>${translate('state_' + source.to)}</span>
          </span>`
        )
      }
      if(source.type === '7'){
        return(
          `<span>${source.sourceid === '35' || source.sourceid === '36' ? translate("lng_subevent_" + source.eventid) + 'L' + source.from : translate("lng_subevent_" + source.eventid)}</span>`
        )
      }

    }

  }
};
</script>
<style>
.event-detail-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.event-type-icon {
  display: inline-block;
  opacity: 0.5;
}
.image-center {
  align-items: center;
  justify-content: center;
  display: flex;
}
.event-detail-item p {
  margin: 12px;
}
.event-detail-item p .v-image {
  display: inline-block;
  height: 16px;
  width: 16px;
  margin: 0 4px;
  position: relative;
  top: 2px;
}
.md-whiteframe-6dp {
  text-transform: capitalize;
  text-align: center;
  background: #455a64;
  color: #fff;
  -moz-border-radius: 5px;
  border-radius: 5px;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),
    0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  line-height: 2rem;
  font-size: 1.79rem;
  margin: 1.2rem 0;
}
</style>
